import { Dispatch, SetStateAction, useCallback } from "react"
import { Grid } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { ResourceFiltersTypes } from "../../../createOrderTypes"
import { FilterSearch } from "../../FilterSearch"
import { ViewType } from "../resourceBookingCalendars/BookingViewMenu"

import { BookPeriodFilter } from "./BookPeriodFilter"
import { ResourceFilterMenu } from "./ResourceFilterMenu"

const useStyles = makeStyles()(() => ({
    // Without it min-content is every control in a line, and they overflow the header's track.
    track: {
        minWidth: 0,
    },
}))

type ResourceFiltersProps = Readonly<{
    filters: ResourceFiltersTypes
    setFilters: Dispatch<SetStateAction<ResourceFiltersTypes>>
    selectedView: ViewType
    isTimeline?: boolean
    userId: number
    isSpecialFlow: boolean
    isRecurringBooking?: boolean
    /** Remounts the chips, which otherwise seed from `filters` only once — see `ResourceFilterMenu`. */
    chipsSeed?: number
}>

export function ResourceFilters({
    filters,
    userId,
    setFilters,
    selectedView,
    isTimeline,
    isSpecialFlow,
    isRecurringBooking = false,
    chipsSeed,
}: ResourceFiltersProps) {
    const { classes } = useStyles()

    const handleSearch = useCallback(
        (searchText: string) => {
            setFilters((prev) => {
                if (prev.search === searchText) return prev
                return { ...prev, search: searchText }
            })
        },
        [setFilters],
    )

    const isTimelineView = selectedView === ViewType.TIMELINE

    return (
        <Grid container className={classes.track} gap="1rem" alignItems="center" flexWrap="wrap">
            <FilterSearch search={filters.search} setSearch={handleSearch} debounceMs={400} />
            {isTimelineView && (
                <BookPeriodFilter
                    isBookedPeriod={!!filters.isBookedPeriod}
                    setFilters={setFilters}
                    isSpecialFlow={isSpecialFlow}
                    isRecurringBooking={isRecurringBooking}
                />
            )}
            <ResourceFilterMenu
                key={chipsSeed}
                filters={filters.filters}
                userId={userId}
                setFilters={setFilters}
                isTimeline={isTimeline}
                inline
            />
        </Grid>
    )
}
